import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const PartyNotFound = (props) => {
  const classes = useStyles();

  const { t } = useTranslation();

  return (
    <div className={classes.screen}>
      <Typography variant="h5" color="primary">
        {t("party.partyNotFoundTitle")}
      </Typography>
      <div style={{ height: 20 }} />
      <Typography variant="body1">{t("party.partyNotFound")}</Typography>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  screen: {
    display: "flex",
    height: "100vh",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default PartyNotFound;
